"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { BrandLogo } from "@/components/BrandLogo";
import { AccountViewSwitcher } from "@/components/AccountViewSwitcher";
import {
  getEffectiveUser,
  getHomePath,
  getSessionToken,
  getStoredUser,
} from "@/lib/session";

/**
 * Logo top-left. When signed in (not home/enter), show compact view switcher.
 */
export function SiteHeader() {
  const pathname = usePathname();
  const isHome = pathname === "/";
  const isEnter = pathname === "/enter" || pathname.startsWith("/enter/");
  const [logoHref, setLogoHref] = useState("/");
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const refresh = () => {
      const token = getSessionToken();
      const user = getStoredUser();
      setLoggedIn(Boolean(token && user));
      setLogoHref(getHomePath(getEffectiveUser() ?? user));
    };
    refresh();
    window.addEventListener("virtuous:view-change", refresh);
    return () => window.removeEventListener("virtuous:view-change", refresh);
  }, [pathname]);

  if (isHome || isEnter) {
    return null;
  }

  return (
    <header className="site-header sticky top-0 z-50 backdrop-blur-md">
      <div className="mx-auto flex w-full max-w-full min-w-0 flex-wrap items-center gap-2 px-3 py-2 sm:px-4 sm:py-2.5">
        <BrandLogo size="sm" withText={false} href={logoHref} />
        {loggedIn ? (
          <div className="ml-auto min-w-0 max-w-[min(100%,22rem)] shrink">
            <AccountViewSwitcher variant="compact" />
          </div>
        ) : null}
      </div>
    </header>
  );
}
